import $api from '../services';

export default {
    list(params) {
        return $api.get('/minutes', params);
    },
    featured(params) {
        return $api.get('/minutes/featured', params);
    },
    create(params) {
        return $api.post('/minutes', params);
    },
    read(id) {
        return $api.get(`/minutes/${id}`);
    },
    update(id, params) {
        return $api.put(`/minutes/${id}`, params);
    },
    delete(id) {
        return $api.delete(`/minutes/${id}`);
    },
    uploadImage(param) {
        return $api.post('/minutes/photo', param);
    },
    uploadVideo(param) {
        return $api.post('/minutes/video', param);
    },
    removePosterPhoto(id) {
        return $api.delete(`/minutes/${id}/poster`);
    },
    startVideoUpload(params) {
        return $api.post('minutes/video/start', params);
    },
    uploadVideoChunks(params) {
        return $api.post('minutes/video/upload', params, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            maxBodyLength: 1000000000,
            maxContentLength: 100000000
        });
    },
    completeVideoUpload(params) {
        return $api.post('minutes/video/complete', params);
    }
};
